import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    createJobType,
    updateJobType,
    toggleJobTypeActive,
    reorderJobTypes,
} from '../api/jobTypesApi';

function invalidateAll(queryClient) {
    queryClient.invalidateQueries({ queryKey: ['jobTypes'] });
    queryClient.invalidateQueries({ queryKey: ['adminJobTypes'] });
}

export function useCreateJobType() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (name) => createJobType(name),
        onSuccess: () => invalidateAll(queryClient),
    });
}

export function useUpdateJobType() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, name }) => updateJobType(id, name),
        onSuccess: () => invalidateAll(queryClient),
    });
}

export function useToggleJobTypeActive() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => toggleJobTypeActive(id),
        onSuccess: () => invalidateAll(queryClient),
    });
}

export function useReorderJobTypes() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (orderedIds) => reorderJobTypes(orderedIds),
        onSuccess: () => invalidateAll(queryClient),
    });
}
